import auth from './auth'

export const authGuard = (to, from, next) => {
  return auth
    .check()
    .then(() => next())
    .catch(() => next('/login'))
}
export const guestGuard = (to, from, next) => {
  return auth
    .check()
    .then(() => next('/'))
    .catch(() => next())
}

const permissionGuard = (permission) => (to, from, next) => {
  if (auth.checkPermission(permission)) {
    next()
  } else {
    next(false)
  }
}

const adminGuard = () => (to, from, next) => {
  if (auth.isAdmin()) {
    next()
  } else {
    next(false)
  }
}

const mainPageGuard = (to, from, next) => {
  if (auth.checkPermission('web_main')) {
    return next()
  }
  if (auth.checkPermission('web_sales')) {
    return next('/reports/sales')
  }
  if (auth.checkPermission('web_service')) {
    return next('/service')
  }
}

export default [
  {
    path: '/login',
    component: require('./pages/login.vue').default,
    beforeEnter: guestGuard,
  },
  {
    path: '/register',
    component: require('./pages/register.vue').default,
    beforeEnter: guestGuard,
  },
  {
    path: '/',
    component: require('./pages/index.vue').default,
    beforeEnter: mainPageGuard,
  },
  {
    path: '/index',
    component: require('./pages/index.vue').default,
    beforeEnter: mainPageGuard,
  },
  {
    path: '/machines',
    component: require('./pages/machines/index.vue').default,
    beforeEnter: permissionGuard('web_ta'),
  },
  {
    path: '/map',
    component: require('./pages/machines/map.vue').default,
    beforeEnter: permissionGuard('web_ta'),
  },
  {
    path: '/news',
    component: require('./pages/news/index.vue').default,
    beforeEnter: permissionGuard('web_news'),
  },
  {
    path: '/news/:uid',
    props: true,
    component: require('./pages/news/_id/index.vue').default,
    beforeEnter: permissionGuard('web_news_once'),
  },
  {
    path: '/notifications',
    component: require('./pages/notifications/index.vue').default,
    beforeEnter: permissionGuard('web_notifications'),
  },
  {
    path: '/machines/:id',
    component: require('./pages/machines/_id.vue').default,
    props: true,
    children: [
      {
        path: '/',
        component: require('./pages/machines/_id/index.vue').default,
        beforeEnter: permissionGuard('web_ta_main'),
      },
      {
        path: 'money',
        component: require('./pages/machines/_id/money.vue').default,
        beforeEnter: permissionGuard('web_ta_money'),
      },
      {
        path: 'matrix',
        component: require('./pages/machines/_id/matrix.vue').default,
        beforeEnter: permissionGuard('web_ta_matrix'),
      },
      {
        path: 'modem',
        component: require('./pages/machines/_id/modem.vue').default,
        beforeEnter: permissionGuard('web_ta_modem'),
      },
      {
        path: 'schedule',
        component: require('./pages/machines/_id/schedule.vue').default,
        beforeEnter: permissionGuard('web_ta_schedule'),
      },
      {
        path: 'cards',
        component: require('./pages/machines/_id/cards.vue').default,
        beforeEnter: permissionGuard('web_ta_magnet'),
      },
      {
        path: 'eva',
        component: require('./pages/machines/_id/eva/index.vue').default,
        beforeEnter: permissionGuard('web_ta_eva'),
      },
      {
        path: 'eva/:eva_id',
        component: require('./pages/machines/_id/eva/_eva_id.vue').default,
        beforeEnter: permissionGuard('web_ta_eva'),
        props: true,
      },
    ],
  },
  {
    path: '/reports',
    redirect: '/reports/sales',
  },
  {
    path: '/reports/sales',
    component: require('./pages/reports/sales.vue').default,
    beforeEnter: permissionGuard('web_sales'),
  },
  {
    path: '/reports/expenditure',
    component: require('./pages/reports/expenditure.vue').default,
    beforeEnter: permissionGuard('web_rate'),
  },
  {
    path: '/reports/encashment',
    component: require('./pages/reports/encashment.vue').default,
    beforeEnter: permissionGuard('web_collect'),
  },
  {
    path: '/reports/events',
    component: require('./pages/reports/events/index.vue').default,
    beforeEnter: permissionGuard('web_events'),
  },
  {
    path: '/reports/events/:id',
    component: require('./pages/reports/events/_id.vue').default,
    beforeEnter: adminGuard(),
    props: true,
  },
  {
    path: '/reports/downtime',
    component: require('./pages/reports/downtime.vue').default,
    beforeEnter: permissionGuard('web_downtime'),
  },
  {
    path: '/reports/notifications',
    component: require('./pages/reports/notifications.vue').default,
    beforeEnter: permissionGuard('web_alerts'),
  },
  {
    path: '/reports/receipts',
    component: require('./pages/reports/receipts.vue').default,
    beforeEnter: permissionGuard('web_bills'),
  },
  {
    path: '/service',
    component: require('./pages/service.vue').default,
    beforeEnter: permissionGuard('web_service'),
  },
  {
    path: '/settings',
    redirect: '/settings/recipes/products',
  },
  {
    path: '/settings/recipes',
    redirect: '/settings/recipes/products',
  },
  {
    path: '/settings/recipes',
    component: require('./pages/settings/recipes.vue').default,
    beforeEnter: permissionGuard('web_recipes'),
    children: [
      {
        path: 'products',
        component: require('./pages/settings/recipes/products/index.vue').default,
      },
      {
        path: 'products/create',
        component: require('./pages/settings/recipes/products/_id.vue').default,
      },
      {
        path: 'products/:id',
        props: true,
        component: require('./pages/settings/recipes/products/_id.vue').default,
      },
      {
        path: 'ingredients',
        component: require('./pages/settings/recipes/ingredients.vue').default,
      },
    ],
  },
  {
    path: '/settings/schedule',
    component: require('./pages/settings/schedule.vue').default,
    beforeEnter: permissionGuard('web_schedule'),
  },
  {
    path: '/settings/notifications',
    component: require('./pages/settings/notifications/index.vue').default,
    beforeEnter: permissionGuard('web_alert_settings'),
  },
  {
    path: '/settings/notifications/:id',
    props: true,
    component: require('./pages/settings/notifications/_id.vue').default,
    beforeEnter: permissionGuard('web_alert_settings'),
  },
  {
    path: '/settings/users',
    component: require('./pages/settings/users.vue').default,
    beforeEnter: permissionGuard('web_users'),
  },
  {
    path: '/settings/matrices',
    component: require('./pages/settings/matrices/index.vue').default,
    beforeEnter: permissionGuard('web_matrix'),
  },
  {
    path: '/settings/matrices/create',
    component: require('./pages/settings/matrices/_id.vue').default,
    beforeEnter: permissionGuard('web_matrix'),
  },
  {
    path: '/settings/matrices/:id',
    component: require('./pages/settings/matrices/_id.vue').default,
    beforeEnter: permissionGuard('web_matrix'),
    props: true,
  },
  {
    path: '/settings/catalogs',
    component: require('./pages/settings/catalogs.vue').default,
    beforeEnter: adminGuard(),
  },
  {
    path: '/tariffs',
    component: require('./pages/tariffs.vue').default,
    // beforeEnter: permissionGuard('web_users'), // todo
  },
  {
    path: '/admin',
    redirect: '/admin/limits',
  },
  {
    path: '/admin/limits',
    component: require('./pages/admin/limits.vue').default,
    beforeEnter: permissionGuard('web_thresholds'),
  },
  {
    path: '/admin/documents',
    component: require('./pages/admin/documents.vue').default,
    beforeEnter: permissionGuard('web_checklist'),
    children: [
      {
        path: '/',
        component: require('./pages/admin/documents/index').default,
      },
      {
        path: 'checklists',
        component: require('./pages/admin/documents/checklists.vue').default,
      },
    ],
  },
  {
    path: '/admin/models',
    component: require('./pages/admin/models/index.vue').default,
    beforeEnter: permissionGuard('web_models'),
  },
  {
    path: '/admin/models/:id',
    props: true,
    component: require('./pages/admin/models/_id.vue').default,
    beforeEnter: permissionGuard('web_models'),
  },
  {
    path: '/admin/info',
    component: require('./pages/admin/info.vue').default,
    // beforeEnter: permissionGuard(''),
    children: [
      {
        path: '/',
        component: require('./pages/admin/info/contacts.vue').default,
      },
      {
        path: 'agreement',
        component: require('./pages/admin/info/agreement.vue').default,
      },
    ],
  },
  {
    path: '/help',
    component: require('./pages/help.vue').default,
  },
  {
    path: '/orders',
    component: require('./pages/orders.vue').default,
    beforeEnter: permissionGuard('web_requests'),
    children: [
      {
        path: '/',
        redirect: '/orders/equipment',
      },
      {
        path: 'equipment',
        component: require('./pages/orders/equipment/index.vue').default,
      },
      {
        path: 'ingredients',
        component: require('./pages/orders/ingredients/index.vue').default,
      },
      {
        path: 'ingredients/create',
        component: require('./pages/orders/ingredients/create.vue').default,
      },
      {
        path: 'equipment/create',
        component: require('./pages/orders/equipment/create.vue').default,
      },
      {
        path: 'equipment/:id',
        props: true,
        component: require('./pages/orders/equipment/_id.vue').default,
      },
      {
        path: 'ingredients/:id',
        props: true,
        component: require('./pages/orders/ingredients/_id.vue').default,
      },
    ],
  },
  {
    path: '/emulator',
    component: require('./pages/emulator.vue').default,
  },
  {
    path: '/billing/cash-flow',
    component: require('./pages/billing/cash-flow/index.vue').default,
    beforeEnter: permissionGuard('web_billing_main'),
    children: [
      {
        path: '/',
        redirect: '/billing/cash-flow/refills-and-refunds/',
      },
      {
        path: 'refills-and-refunds',
        component: require('./pages/billing/cash-flow/refills-and-refunds.vue').default,
      },
      {
        path: 'write-offs',
        component: require('./pages/billing/cash-flow/write-offs.vue').default,
      },
    ],
  },
  {
    path: '/billing/organizations',
    component: require('./pages/billing/organizations/index.vue').default,
    beforeEnter: permissionGuard('web_billing_main'),
    children: [
      {
        path: '/',
        redirect: '/billing/organizations/search/',
      },
      {
        path: 'list',
        component: require('./pages/billing/organizations/list.vue').default,
      },
      {
        path: 'tariffs',
        component: require('./pages/billing/organizations/tariffs.vue').default,
      },
      {
        path: 'search',
        component: require('./pages/billing/organizations/search.vue').default,
      },
    ],
  },
  {
    path: '/billing/logs',
    component: require('./pages/billing/logs/index.vue').default,
    beforeEnter: permissionGuard('web_billing_main'),
    children: [
      {
        path: '/',
        redirect: '/billing/logs/billing/',
      },
      {
        path: 'billing',
        component: require('./pages/billing/logs/billing.vue').default,
      },
      {
        path: 'clients',
        component: require('./pages/billing/logs/clients.vue').default,
      },
      {
        path: 'admins',
        component: require('./pages/billing/logs/admins.vue').default,
      },
    ],
  },
  {
    path: '/billing/settings',
    component: require('./pages/billing/settings/index.vue').default,
    beforeEnter: permissionGuard('web_billing_main'),
    children: [
      {
        path: '/',
        redirect: '/billing/settings/regions/',
      },
      {
        path: 'regions',
        component: require('./pages/billing/settings/regions.vue').default,
      },
      {
        path: 'commands',
        component: require('./pages/billing/settings/commands.vue').default,
      },
    ],
  },
  {
    path: '/billing/notifications',
    component: require('./pages/billing/notifications/index.vue').default,
    beforeEnter: permissionGuard('web_billing_notifications'),
    children: [
      {
        path: '/',
        redirect: '/billing/notifications/create/',
      },
      {
        path: 'create',
        component: require('./pages/billing/notifications/create.vue').default,
      },
      {
        path: 'list',
        component: require('./pages/billing/notifications/list.vue').default,
      },
    ],
  },
  {
    path: '/billing/news',
    component: require('./pages/billing/news/index.vue').default,
    beforeEnter: permissionGuard('web_billing_news'),
    children: [
      {
        path: '/',
        redirect: '/billing/news/news-list/',
      },
      {
        path: 'create-news',
        component: require('./pages/billing/news/create-news.vue').default,
      },
      {
        path: 'create-notices',
        component: require('./pages/billing/news/create-notices.vue').default,
      },
      {
        path: 'news-list',
        component: require('./pages/billing/news/news-list.vue').default,
      },
    ],
  },
  {
    path: '/billing',
    redirect: '/billing/organizations/list',
    // component: require('./pages/billing/index.vue').default,
    beforeEnter: permissionGuard('web_billing_main'),
    children: [
      // {
      //   path: 'unloading',
      //   component: require('./pages/billing/unloading/index.vue').default,
      // },
      // {
      //   path: 'panel',
      //   component: require('./pages/billing/panel/index.vue').default,
      // },
      // {
      //   path: 'rights',
      //   component: require('./pages/billing/rights/index.vue').default,
      // },
      // {
      //   path: 'logs',
      //   component: require('./pages/billing/logs/index.vue').default,
      // },
    ],
  },
  {
    path: '/modems',
    component: require('./pages/modems/index.vue').default,
    beforeEnter: permissionGuard('web_modems'),
    children: [
      {
        path: '/',
        component: require('./pages/modems/index/index.vue').default,
      },
      {
        path: 'deleted',
        component: require('./pages/modems/index/deleted.vue').default,
        beforeEnter: permissionGuard('web_modems_deleted'),
      },
      {
        path: 'broadcasts',
        component: require('./pages/modems/index/broadcasts/index.vue').default,
      },
    ],
  },
  {
    path: '/modems/broadcasts/:id',
    props: true,
    component: require('./pages/modems/index/broadcasts/_id.vue').default,
    beforeEnter: permissionGuard('web_modems'),
  },
  {
    path: '/modems/:uid',
    props: true,
    component: require('./pages/modems/_uid/index.vue').default,
    beforeEnter: permissionGuard('web_modems_edit'),
  },
  {
    path: '/commands/:id',
    props: true,
    component: require('./pages/commands/_id.vue').default,
    beforeEnter: permissionGuard('web_modems_edit'),
  },
  {
    path: '/receipts',
    component: require('./pages/receipts/index.vue').default,
    beforeEnter: permissionGuard('web_bill_total'),
  },
  {
    path: '/receipts/:id',
    props: true,
    component: require('./pages/receipts/_id.vue').default,
    beforeEnter: adminGuard(),
  },
  {
    path: '/personal',
    component: require('./pages/personal.vue').default,
    children: [
      {
        path: '/',
        component: require('./pages/personal/index.vue').default,
        beforeEnter: permissionGuard('web_personal_main'),
      },
      {
        path: 'signatory',
        component: require('./pages/personal/signatory.vue').default,
        beforeEnter: permissionGuard('web_personal_organization'),
      },
      {
        path: 'organization',
        component: require('./pages/personal/organization.vue').default,
        beforeEnter: permissionGuard('web_personal_organization'),
      },
      {
        path: 'organization/create',
        component: require('./pages/personal/organization.vue').default,
        beforeEnter: permissionGuard('web_personal_organization'),
        name: 'new_organization',
      },
      {
        path: 'organization/:id',
        component: require('./pages/personal/organization.vue').default,
        beforeEnter: permissionGuard('web_personal_organization'),
        props: true,
        name: 'organization',
      },
      {
        path: 'refresh',
        component: require('./pages/personal/refresh.vue').default,
        beforeEnter: permissionGuard('web_personal_password'),
      },
    ],
  },
  {
    path: '/payments/history',
    component: require('./pages/payments/history.vue').default,
    redirect: '/payments/history/charges',
    children: [
      {
        path: 'charges',
        component: require('./pages/payments/history/charges.vue').default,
      },
      {
        path: 'refills',
        component: require('./pages/payments/history/refills.vue').default,
      },
    ],
  },
  {
    path: '/queue',
    component: require('./pages/queue.vue').default,
  },
  ...(process.env.NODE_ENV === 'development' ? [
    {
      path: '/dev',
      component: require('./pages/dev.vue').default,
    },
  ] : []),
  {
    path: '*',
    component: require('./pages/not-found.vue').default,
  },
]



// WEBPACK FOOTER //
// ./resources/assets/js/routes.js